import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useClientAuth } from "hooks/useAxios"

const useMetabase = (verdikt_alias, compared_nodes_id, website_id) => {
  const [url, setUrl] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const { i18n } = useTranslation()

  const client = useClientAuth()

  useEffect(() => {
    if (!verdikt_alias) {
      setUrl(null)
      setIsLoading(false)
      setError(null)
      return
    }

    let isMounted = true
    const currentLocale = i18n.language || "fr"

    setIsLoading(true)
    setError(null)
    setUrl(null)

    const compare_node_ids = compared_nodes_id
      ? compared_nodes_id.join(",")
      : ""

    // Optional dashboard filter (e.g. RGAA/RGESN audits scoped to one website).
    const websiteIdParam = website_id != null ? `&website_id=${website_id}` : ""

    client
      .get(
        `/api/metabase/generate_url?alias=${verdikt_alias}&locale=${currentLocale}&compare_node_ids=${compare_node_ids}${websiteIdParam}`
      )
      .then((response) => {
        if (!isMounted) return
        if (!response.status.toString().startsWith("2")) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        if (response.data.url) {
          setUrl(response.data.url)
          setError(null)
        } else {
          throw new Error("URL metabase non trouvée")
        }
      })
      .catch((error) => {
        if (!isMounted) return
        console.error("Error fetching Metabase question URL:", error)
        const serverError =
          error?.response?.data?.error || error?.response?.data?.message

        setError(
          serverError ||
            error.message ||
            "Une erreur est survenue lors du chargement"
        )
        setUrl(null)
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [verdikt_alias, i18n.language, website_id])

  return {
    questionUrl: url,
    isLoading,
    error,
    hasData: !!url && !error,
  }
}

export default useMetabase
